import request from './request';

export interface SessionConfig {
  id: string;
  version: number;
  status: 'draft' | 'published' | 'archived';
  processingMode: 'stt_llm' | 'multimodal';
  promptPart1?: string | null;
  modelParams?: string | null;
  sttProviderCode?: string | null;
  sttModelId?: string | null;
  llmProviderCode?: string | null;
  llmModelId?: string | null;
  multimodalProviderCode?: string | null;
  multimodalModelId?: string | null;
  publishedAt?: number | null;
  archivedAt?: number | null;
  createdBy?: string;
  remark?: string;
  createdAt: number;
  updatedAt: number;
}

export interface CreateSessionConfigRequest {
  processingMode: 'stt_llm' | 'multimodal';
  promptPart1?: string | null;
  modelParams?: string | null;
  sttProviderCode?: string | null;
  sttModelId?: string | null;
  llmProviderCode?: string | null;
  llmModelId?: string | null;
  multimodalProviderCode?: string | null;
  multimodalModelId?: string | null;
  remark?: string;
}

export interface UpdateSessionConfigRequest {
  processingMode?: 'stt_llm' | 'multimodal';
  promptPart1?: string | null;
  modelParams?: string | null;
  sttProviderCode?: string | null;
  sttModelId?: string | null;
  llmProviderCode?: string | null;
  llmModelId?: string | null;
  multimodalProviderCode?: string | null;
  multimodalModelId?: string | null;
  remark?: string;
}

// 获取当前发布版本
export async function getPublishedConfig(): Promise<SessionConfig | null> {
  return request.get('/api/admin/v1/session-config') as any;
}

// 获取所有版本
export async function getConfigVersions(): Promise<SessionConfig[]> {
  return request.get('/api/admin/v1/session-config/versions') as any;
}

// 获取指定版本
export async function getConfigById(id: string): Promise<SessionConfig> {
  return request.get(`/api/admin/v1/session-config/${id}`) as any;
}

// 创建新版本
export async function createConfig(data: CreateSessionConfigRequest): Promise<SessionConfig> {
  return request.post('/api/admin/v1/session-config', data) as any;
}

// 更新草稿版本
export async function updateConfig(id: string, data: UpdateSessionConfigRequest): Promise<SessionConfig> {
  return request.put(`/api/admin/v1/session-config/${id}`, data) as any;
}

// 发布版本
export async function publishConfig(id: string): Promise<SessionConfig> {
  return request.post(`/api/admin/v1/session-config/${id}/publish`) as any;
}

// 归档版本
export async function archiveConfig(id: string): Promise<SessionConfig> {
  return request.post(`/api/admin/v1/session-config/${id}/archive`) as any;
}

// 删除草稿版本
export async function deleteConfig(id: string): Promise<void> {
  return request.delete(`/api/admin/v1/session-config/${id}`) as any;
}

// 复制版本创建新草稿
export async function duplicateConfig(id: string): Promise<SessionConfig> {
  return request.post(`/api/admin/v1/session-config/${id}/duplicate`) as any;
}
